import * as types from './mutation-types'
import { getUserMenu } from '../api/authManage/auth'
import customLocalStorage from 'store'
import router from '@/router/index'

const actions = {
  getAuthTree ({ commit }) {
    return new Promise((resolve) => {
      let userid = customLocalStorage.get('UserBaseInfo').id
      getUserMenu({ user_id: userid }).then(res => {
        console.log('data', res.data)
        // 李根 发现访问首页的时候，突然白屏，修复这里的问题重新登录。
        if (res.data.length > 0) {
          commit(types.SET_AUTHTREE, res.data)

          let dataList = res.data.map(item => { return item })
          resolve(dataList)
        } else {
          router.push({
            path: '/login'
          })
        }
      })
    })
  }
}
export default actions


// WEBPACK FOOTER //
// ./src/store/actions.js